import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleModalService {
  private selectedRoleSubject = new BehaviorSubject<any>(null);
  public selectedRole$ = this.selectedRoleSubject.asObservable();

  constructor() { }

  // Method to set the selected role for editing
  setSelectedRole(role: any) {
    this.selectedRoleSubject.next(role);
  }

  // Method to clear the selected role
  clearSelectedRole() {
    this.selectedRoleSubject.next(null);
  }
}
